"use client";

import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavigationConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-5 w-20 bg-muted-light/20 animate-pulse rounded" />
        <div className="h-5 w-24 bg-muted-light/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/20 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light/20 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light/20 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-muted-light hover:text-foreground-dark transition-colors duration-200 hover:underline underline-offset-4">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer ref={ref} className="w-full bg-dark-background text-foreground-dark py-12 px-6">
      <div className={`max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div className="flex flex-col justify-center">
          <p className="text-sm text-muted-light">
            &copy; 2020 MANAGEMENT 101 LLC. All rights reserved.
          </p>
        </div>

        {}
        <div className="flex flex-col justify-center items-center">
          <MenuProvider menu_id="3" className="w-full flex justify-center">
            <FooterNavigationConsumer />
          </MenuProvider>
        </div>

        {}
        
      </div>
    </footer>;
}